// Card IDs that each program lens highlights and expands
export const PROGRAM_CARD_IDS = {
  CCM: ["goals", "carePlans", "encounters", "barriers", "careTasks", "preventiveCare"],
  RPM: ["rpmDeviceReadings", "rpmDeviceOrdering", "vitals", "deviceOrders", "encounters", "goals"],
  BHI: ["assessments", "encounters", "barriers", "socialDeterminants", "socialHistory", "resources", "goals"],
};

// Colors for each program lens (distinct from agenda teal #79b8c9)
export const PROGRAM_COLORS = {
  CCM: { main: "#4ade80", dark: "#16a34a", light: "rgba(74,222,128,0.2)" },
  RPM: { main: "#a78bfa", dark: "#7c3aed", light: "rgba(167,139,250,0.2)" },
  BHI: { main: "#fb923c", dark: "#ea580c", light: "rgba(251,146,60,0.2)" },
};

// Summary card IDs injected into column 1 when a lens is active
export const PROGRAM_SUMMARY_CARD_IDS = {
  CCM: "ccmSummary",
  RPM: "rpmSummary",
  BHI: "bhiSummary",
};

// Priority order for lens color resolution (first match wins)
export const LENS_PRIORITY = ["CCM", "RPM", "BHI"];
